import { getErrorMessage } from '../../errorBuilder';
import { get, post } from '../../service';
import { UrlBuilder } from '../../urlBuilder';

export const getClientQueryList = async (ticketId, params) => {
  const builder = new UrlBuilder(`/query/list/${ticketId}`);

  builder.add('page', params?.page || 1);
  builder.add('pageSize', params?.limit || 10);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const clientCreateQuery = async (payload) => {
  const builder = new UrlBuilder(`/query/create`);

  try {
    const response = await post(builder.toString(), payload);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const clientViewAttachment = async (payload) => {
  const builder = new UrlBuilder(`/query/view-document`);

  try {
    const response = await post(builder.toString(), payload);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const clientRemoveAttachment = async (payload) => {
  const builder = new UrlBuilder(`/query/delete-document`);

  try {
    const response = await post(builder.toString(), payload);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};
